/**
 * Global Swiper vendor registration.
 *
 * Imports Swiper core + commonly used modules and exposes them
 * on `window.WombatSwiper` so any block can use them without
 * bundling Swiper separately.
 *
 * Usage in a block view.js:
 *   const { Swiper, Pagination, EffectFade, Autoplay, A11y } = window.WombatSwiper;
 *
 * @package Wombat
 */

import Swiper from "swiper";
import {
	Pagination,
	EffectFade,
	Autoplay,
	A11y,
	Navigation,
} from "swiper/modules";

window.WombatSwiper = {
	Swiper,
	Pagination,
	EffectFade,
	Autoplay,
	A11y,
	Navigation,
};
